/**
 * エージェント名・連携表示名など、第三者供給値をプロンプトの構造的な区切り文字
 * （引用符・Markdown 強調記号）の内側へ埋め込む際に使う無害化関数群。
 *
 * 値の保存時（{@link AgentNameSchema}）と埋め込み時（プロンプト生成側の防御的な
 * 再適用）の双方から同一実装を参照させることで、畳み込みルールが箇所ごとに
 * ずれることを防ぐ。
 */
/**
 * 二重引用符を全角引用符へ畳み込む。
 *
 * `You are "<name>"` や `from="<name>"` のように、値が引用符で囲まれた文脈へ
 * 埋め込まれる場合に使う。値自身に `"` が含まれていても引用構造を破れない。
 */
export function foldDoubleQuotes(text) {
    return text.replace(/"/g, '”');
}
/**
 * アスタリスクを全角アスタリスクへ畳み込む。
 *
 * `**<name>**` のように、値が Markdown の強調記号で囲まれた文脈へ埋め込まれる
 * 場合に使う。値自身に `*` が含まれていても強調区間を early-close できない。
 */
export function foldAsterisks(text) {
    return text.replace(/\*/g, '＊');
}
/**
 * 山括弧を全角山括弧へ畳み込む。
 *
 * `<peer-agent-message from="<name>">` のように、値がタグの属性値へ埋め込まれる場合に
 * 使う。値自身に `>` が含まれていてもタグを閉じられず、`<` が含まれていても新たなタグを
 * 開始できないため、属性値だけから偽の帰属ヘッダーを組み立てられない。
 */
export function foldAngleBrackets(text) {
    return text.replace(/</g, '＜').replace(/>/g, '＞');
}
//# sourceMappingURL=fold-display-name.js.map